<div class="dialog-container">
    <h1 mat-dialog-title>{{ 'INFO_POP_UP.TITLE' | translate }}</h1>
    <div mat-dialog-content [innerHTML]="'INFO_POP_UP.CONTENT' | translate"></div>
    <div mat-dialog-actions fxLayoutAlign="end">
        <a
            mat-raised-button
            [href]="'INFO_POP_UP.LINK' | translate"
            target="_blank"
            *ngIf="checkTranslationKeyExists('INFO_POP_UP.LINK')"
            >{{ 'COMMON.MORE' | translate }}</a
        >
        <button mat-raised-button color="primary" [mat-dialog-close]="true">
            {{ 'INFO_POP_UP.NEXT' | translate }}
        </button>
    </div>
</div>
